import { SliderHTMLElement } from '../../../../common/slider/slider';

const ATTRIBUTES = ['data-tabs-count', 'data-edit.mode'];

export class CardsTabberHTMLElement extends SliderHTMLElement {
    private isMobile = window.matchMedia('(max-width: 767.9px)');

    constructor() {
        super({
            containerSelector: '.tabs-nav__wrapper',
            indicatorSelector: '.nav-item',
            itemsContainerSelector: '.tabs-nav',
            itemSelector: '.nav-item', // not used
            nextNavSelector: '.tabber__next',
            prevNavSelector: '.tabber__prev'
        });
        this.sliderType = "Cards Tabber";
        this.auxiliarySetActiveItemCallback = this.mobileNavigation;
        this.indicatorCallback = this.setActiveTab;
    }

    static get observedAttributes(): string[] {
        return ATTRIBUTES;
    }

    public attributeChangedCallback(name: string, oldValue: string, newValue: string): void {
        if (!ATTRIBUTES.includes(name)) {
            return;
        }

        if (oldValue === newValue) {
            return;
        }

        super.attributeChangedCallback(name, oldValue, newValue);

        setTimeout(() => {
            switch (name) {
                case 'data-tabs-count':
                    this.itemsTotal = Number.parseInt(newValue);
                    this.setInitialActiveTab();
                    break;
            }
        })
    }

    private mobileNavigation = (index: number) => {
        if (this.isMobile.matches) {
            this.setActiveTab(index);
        }
    };

    private setActiveTab = (index: number) => {
        /* nav */
        const prevNav = this.querySelector('.nav-item-active')
        const prevNavIndex = prevNav && Array.from(prevNav.parentElement.children).findIndex(child => child === prevNav);
        if (prevNavIndex === index) {
            return;
        }
        const nextNav = Array.from(this.querySelectorAll('.nav-item'))[index];
        
        if (prevNav) {
            const enterDirection = prevNavIndex > index ? 'enter-right' : 'enter-left';
            nextNav.classList.add(enterDirection);
            setTimeout(() => {
                nextNav.classList.remove(enterDirection);
            }, 300)
        }
        prevNav?.classList.remove('nav-item-active');
        nextNav.classList.add('nav-item-active');
        /* /nav */

        /* panel */
        this.querySelector('.tab-content-active')?.classList.remove('tab-content-active')
        Array.from(this.querySelectorAll('.tab-content'))[index].classList.add('tab-content-active');
        /* /panel */
    };

    private setInitialActiveTab(): void {
        const anchorHash = window.parent.location.hash;
        const hash = anchorHash.startsWith('#') ? anchorHash.substring(1) : anchorHash;
        const anchor = hash ? this.querySelector(`#cards-tabber_${hash}`) : undefined;

        const index = Array.from(this.querySelectorAll('.nav-item')).findIndex(el => el === anchor);
        if (index > -1) {
            this.setActiveTab(index);
            this.reset(index);
        } else {
            this.setActiveTab(this.startingSlideIndex);
            this.reset(this.startingSlideIndex);
        }
    }
}
